var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMarkFullGray12 = function SvgQuestionMarkFullGray12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    fillRule: "evenodd",
    d: "M10.8 6.5a4.8 4.8 0 1 1-9.6 0 4.8 4.8 0 0 1 9.6 0M5.364 4.662a.45.45 0 0 1-.637-.637A1.8 1.8 0 1 1 6.45 7.042v.207a.45.45 0 0 1-.9 0v-.3c0-.432.342-.703.649-.772a.9.9 0 1 0-.835-1.514M6 9.499a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2",
    clipRule: "evenodd"
  })));
};
export { SvgQuestionMarkFullGray12 as ReactComponent };
export default __webpack_public_path__ + "d04cae95d68d5ab1581167bf3174fa32.svg";